import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Route degisiminde scroll behavior:
// - hash yoksa: sayfa ustune scroll (default)
// - hash varsa: ilgili element'e smooth scroll (Footer "Marka Talep Formu" linki gibi anchor navigation)
// React Router 7 SPA modunda browser default hash scroll'u tetiklemez; manuel handler gerekli.
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // DOM render bittikten sonra elementi bulup scroll et (kucuk delay)
      const t = setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          // Element yoksa fallback: sayfa ustu
          window.scrollTo(0, 0);
        }
      }, 100);
      return () => clearTimeout(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
